import { filter, ignoreElements, tap } from "rxjs/operators";
import { IdEventSoundCore } from "../../../utils/sound/IdEventSoundCore";
import { utilSound } from "../../../utils/sound/utilSound";
import { TypeActionBuildings } from "../../player-base/buildings/actionBuildings";
export var epicSoundsBuildingStartMove = function (action$) {
    return action$.pipe(filter(function (action) { return action.type === TypeActionBuildings.StartMove; }), tap(function () { return utilSound.event(IdEventSoundCore.BuildingStartMove); }), ignoreElements());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/sound/epics/epicSoundsBuildingStartMove.ts
// module id = 2405
// module chunks = 3